<template>
  <div class="main-wrapper ourteam-page">
    <layouts-header></layouts-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content">
      <div class="container">
        <section class="ourteam">
          <div class="row">
            <div
              class="col-12 col-sm-6 col-md-4 col-lg-3 team-item"
              v-for="record in OurTeams"
              :key="record.id"
            >
              <div class="info text-center">
                <div class="wrap">
                  <div class="prfile-pic">
                    <img
                      :src="require(`@/assets/img/aboutus/${record.Image}`)"
                      class="img-fluid"
                      alt="Team"
                    />
                  </div>
                  <div class="short-info">
                    <h4>{{ record.Name }}</h4>
                    <h6>{{ record.Role }}</h6>
                  </div>
                </div>
                <div class="more">
                  <div class="short-info">
                    <h4>{{ record.Name }}</h4>
                    <h6>{{ record.Role }}</h6>
                  </div>
                  <p>
                    {{ record.Description }}
                  </p>
                  <ul class="social-medias d-inline-flex">
                    <li class="facebook">
                      <a href="javascript:void(0);"
                        ><i class="fa-brands fa-facebook-f"></i
                      ></a>
                    </li>
                    <li class="instagram">
                      <a href="javascript:void(0);"
                        ><i class="fa-brands fa-instagram"></i
                      ></a>
                    </li>
                    <li class="twitter">
                      <a href="javascript:void(0);"
                        ><i class="fa-brands fa-twitter"></i
                      ></a>
                    </li>
                    <li class="pinterest">
                      <a href="javascript:void(0);"
                        ><i class="fa-brands fa-pinterest"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import OurTeams from "@/assets/json/our-teams.json";
export default {
  data() {
    return {
      OurTeams: OurTeams,
      title: "Our Teams",
      text: "Home",
      text1: "Our Teams",
    };
  },
};
</script>
